import React, { useState, useEffect, useCallback } from "react";
import { withRouter, useHistory } from "react-router-dom";
import bigInt from "big-integer";

import { withStyles } from "@material-ui/core/styles";
import {
  Typography,
  Button,
  Fade,
  FormControlLabel,
  IconButton,
  Switch,
  useTheme,
} from "@material-ui/core";

import CloseIcon from "@material-ui/icons/Close";
import { FadeInWhenVisible } from "../animation";

import CompletedProjectCard from "../poolCard/completedProjectCard";

import AboutStarterCard from "../aboutStarterCard/aboutCard";
import InfoCard from "./components/infoCard/infoCard";
import HowToArticleCard from "./components/howToArticleCard/howToArticleCard";

import StarterIncubatorJpg from "../../assets/starter-incubator.jpg";
import ABCandCoinbaseJpg from "../../assets/ABC-Coinbase.png";
import SwCJpg from "../../assets/stand-w-crypto.jpeg";
import GuideBuidlPng from "../../assets/guide-dive.png";
import GuideTierPng from "../../assets/guide-tier.png";
import GuideVotinglPng from "../../assets/guide-voting.png";
import GuideListPng from "../../assets/guide-listed.png";

import LogoPng from "../../assets/icons/hot-drops.png";

import BuyModalBox from "./components/modal";
import { withNamespaces } from "react-i18next";
import {
  GET_POOLS_SUMMARY_RETURNED,
  toFixed,
  defaultBuyUrls,
  GET_BALANCES_RETURNED,
  SWAP,
  BANNER,
  tokens,
  GET_SWAP_INFO_RETURNED,
} from "../../constants";

import Store from "../../stores";
import { sortPools } from "../../utils/sortPools";
import { useAccount } from "../../contexts/AccountContext";

const styles = (theme) => ({
  root: {
    flex: 1,
    display: "flex",
    width: "100%",
    justifyContent: "center",
    alignItems: "flex-start",
    flexDirection: "column",
    padding: "30px",
    [theme.breakpoints.up("sm")]: {
      flexDirection: "row",
      padding: "70px",
    },
    fontFamily: "Poppins",
    position: "relative",
  },
  mainContainer: {
    display: "flex",
    height: "100%",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "flex-start",
    width: "100%",
    maxWidth: "1140px",
  },
  logo: {
    width: "250px",
    height: "250px",
    objectFit: "contain",
    marginBottom: "1rem",
  },
  mainHeaderGradient: {
    fontSize: "30px",
    lineHeight: "35px",
    fontFamily: "Poppins",
    fontWeight: "bold",
    textAlign: "center",
    // textShadow: "2px 2px " + theme?.colors?.home?.headingShadow,
    // color: theme?.colors?.home?.heading,
    // background: "#FF0000",
    background:
      "linear-gradient(to right, #FF0000 0%, #F000F1 20%, #5521FF 58%, #00EEFF 100%)",
    backgroundClip: "text",
    WebkitBackgroundClip: "text",
    color: "transparent",
    // -webkit-background-clip: text;
    // -webkit-text-fill-color: transparent;

    // background:
    //   "transparent linear-gradient(90deg, #FF0000 0%, #F000F1 20%, #5521FF 58%, #00EEFF 100%) 0% 0% no-repeat padding-box",
    marginBottom: "12px",
    [theme.breakpoints.up("sm")]: {
      fontSize: "60px",
      lineHeight: "75px",
      marginBottom: "20px",
    },
  },
  mainHeader: {
    fontSize: "30px",
    lineHeight: "35px",
    fontFamily: "Poppins",
    fontWeight: "bold",
    textAlign: "center",
    // textShadow: "2px 2px " + theme?.colors?.home?.headingShadow,
    color: theme?.colors?.home?.heading,
    // background: "#FF0000",

    // background:
    //   "transparent linear-gradient(90deg, #FF0000 0%, #F000F1 20%, #5521FF 58%, #00EEFF 100%) 0% 0% no-repeat padding-box",
    marginBottom: "12px",
    [theme.breakpoints.up("sm")]: {
      fontSize: "60px",
      lineHeight: "75px",
      marginBottom: "20px",
    },
  },
  header: {
    fontSize: "30px",
    lineHeight: "35px",
    fontFamily: "Poppins",
    fontWeight: "bold",
    textAlign: "center",
    color: theme?.colors?.home?.heading,
    marginBottom: "10px",
    [theme.breakpoints.up("sm")]: {
      fontSize: "50px",
      lineHeight: "60px",
      maxWidth: "768px",
      marginBottom: "20px",
    },
  },
  headerSecondary: {
    fontSize: "30px",
    lineHeight: "35px",
    fontWeight: "bold",
    textAlign: "left",
    color: theme?.colors?.home?.headingSecondary,
    marginBottom: "30px",
    [theme.breakpoints.up("sm")]: {
      fontSize: "50px",
      lineHeight: "60px",
    },
  },
  headerSubText: {
    fontSize: "16px",
    fontWeight: "normal",
    fontFamily: "Poppins",
    lineHeight: "20px",
    textAlign: "center",
    letterSpacing: "0px",
    color: theme?.colors?.home?.textSecondary,
    width: "100%",
    marginBottom: "30px",
    [theme.breakpoints.up("sm")]: {
      fontSize: "22px",
      lineHeight: "35px",
      maxWidth: "768px",
      marginBottom: "25px",
    },
  },
  headerActionContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    gap: "22px",
    marginBottom: "16px",
    [theme.breakpoints.up("sm")]: {
      marginBottom: "0px",
      flexDirection: "row",
    },
  },
  mainBody: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
  },
  poolsContainer: {
    display: "flex",
    flexDirection: "column",
    marginTop: "40px",
    [theme.breakpoints.up("sm")]: {
      marginTop: "75px",
    },
  },
  poolLabelContainer: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  adContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    borderRadius: "32px",
    cursor: "pointer",
    "& > img": {
      borderRadius: "32px",
    },

    marginTop: "40px",
    [theme.breakpoints.up("sm")]: {
      marginTop: "75px",
    },
  },
  adBannerText: {
    fontSize: "40px",
    color: "#A0A0A0",
  },
  completedContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",

    marginTop: "40px",
    [theme.breakpoints.up("sm")]: {
      marginTop: "75px",
    },
  },
  completedHeader: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "57px",
    width: "100%",
    flexDirection: "column",

    [theme.breakpoints.up("md")]: {
      flexDirection: "row",
    },
  },
  completedRightAlign: {
    display: "flex",
    gap: "20px",
    marginTop: "1.3rem",

    [theme.breakpoints.up("md")]: {
      flexDirection: "40px",
      marginTop: "0rem",
    },
  },
  completedInfoBoxLeft: {
    color: theme?.colors?.home?.infoBoxBackground,
    boxShadow: "0px 10px 60px " + theme?.colors?.containerShadow,
    borderRadius: "32px",
    padding: "24px",
    backgroundColor: theme?.colors?.home?.summaryContainer,
    // marginRight: "40px",
  },
  completedInfoBoxRight: {
    color: theme?.colors?.home?.infoBoxBackground,
    boxShadow: "0px 10px 60px " + theme?.colors?.containerShadow,
    borderRadius: "32px",
    padding: "24px",
    backgroundColor: theme?.colors?.home?.summaryContainer,
  },
  completedInfoBoxTitle: {
    color: "#A0A0A0",
    fontSize: "14px",
    fontWeight: "normal",
    margin: "0",
  },
  completedInfoBoxDescription: {
    color: theme?.colors?.home?.infoBoxDescription,
    fontSize: "16px",
    fontWeight: "medium",
    margin: "0",
  },
  completedTitle: {
    fontFamily: "Poppins",
    display: "flex",
    alignItems: "end",
    fontSize: "30px",
    fontWeight: "600",
    lineHeight: "36px",
    textAlign: "left",
    letterSpacing: "0px",
    color: theme?.colors?.home?.text,
    marginBottom: "12px",
    [theme.breakpoints.down("xs")]: {
      fontSize: "22px",
    },
  },
  completedProjectsLabel: {
    color: "#A0A0A0",
    fontSize: "16px",
    margin: "0",
    fontWeight: "medium",
  },
  aboutContainer: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    marginTop: "40px",
    [theme.breakpoints.up("sm")]: {
      marginTop: "75px",
    },
  },

  infoCardContainerWrapper: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    // margin: "4rem 0 2rem",

    // [theme.breakpoints.down("xs")]: {
    //   margin: "1.5rem 0 0rem",
    // },

    marginTop: "40px",
    [theme.breakpoints.up("sm")]: {
      marginTop: "75px",
    },
  },
  infoCardTitle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "10px",
    marginBottom: "30px",
    [theme.breakpoints.up("sm")]: {
      marginBottom: "50px",
    },
    [theme.breakpoints.down("xs")]: {
      marginBottom: "1rem",
      gap: "8px",
    },
  },
  infoCardContainer: {
    display: "grid",
    gridTemplateColumns: "1fr",
    gridColumnGap: "30px",
    gridRowGap: "40px",

    [theme.breakpoints.up("sm")]: {
      gridTemplateColumns: "1fr 1fr 1fr",
      gridColumnGap: "30px",
      gridRowGap: "40px",
    },
  },
  infoCardLabel: {
    fontFamily: "Poppins",
    display: "flex",
    alignItems: "end",
    fontSize: "25px",
    fontWeight: "600",
    lineHeight: "36px",
    textAlign: "center",
    letterSpacing: "0px",
    color: theme?.colors?.home?.text,

    marginBottom: "0px",
    [theme.breakpoints.down("xs")]: {
      fontSize: "22px",
    },
  },

  howToArticlesContainerWrapper: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    // margin: "4rem 0 2rem",

    // [theme.breakpoints.down("xs")]: {
    //   margin: "1.5rem 0 0rem",
    // },

    marginTop: "40px",
    [theme.breakpoints.up("sm")]: {
      marginTop: "75px",
    },
  },
  howToArticlesTitle: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    marginBottom: "30px",
    [theme.breakpoints.up("sm")]: {
      marginBottom: "50px",
    },
    [theme.breakpoints.down("xs")]: {
      marginBottom: "1rem",
      gap: "8px",
    },
  },
  howToArticlesContainer: {
    display: "grid",
    gridTemplateColumns: "auto",
    gridColumnGap: "30px",
    gridRowGap: "40px",

    [theme.breakpoints.up("sm")]: {
      gridTemplateColumns: "1fr 1fr",
      gridColumnGap: "30px",
      gridRowGap: "40px",
    },

    [theme.breakpoints.up("md")]: {
      gridTemplateColumns: "1fr 1fr 1fr 1fr",
      gridColumnGap: "30px",
      gridRowGap: "40px",
    },
  },
  aboutInnerContainer: {
    display: "flex",
    flexDirection: "column",

    gap: "40px",

    [theme.breakpoints.up("md")]: {
      flexDirection: "row",
    },
    [theme.breakpoints.down("sm")]: {
      gap: "0px",
    },
  },
  aboutRightContainer: {
    marginTop: "2rem",
    [theme.breakpoints.up("md")]: {
      marginTop: "0px",
    },
  },
  poolsLabel: {
    fontFamily: "Poppins",
    display: "flex",
    alignItems: "end",
    fontSize: "30px",
    fontWeight: "600",
    lineHeight: "36px",
    textAlign: "left",
    letterSpacing: "0px",
    color: theme?.colors?.home?.text,
    marginBottom: "30px",
    [theme.breakpoints.up("sm")]: {
      marginBottom: "50px",
    },
    [theme.breakpoints.down("xs")]: {
      marginBottom: "1rem",
      fontSize: "22px",
    },
  },
  howToArticlesAnchor: {
    textDecoration: "none",
    fontSize: "16px",
    fontWeight: "600",
    color: theme?.colors?.wallet?.buttonText,
    transition: "all 0.3s",

    [theme.breakpoints.down("xs")]: {
      fontSize: "14px",
    },

    "&:hover": {
      opacity: "0.7",
    },
  },

  howToArticlesLabel: {
    fontFamily: "Poppins",
    display: "flex",
    alignItems: "end",
    fontSize: "30px",
    fontWeight: "600",
    lineHeight: "36px",
    textAlign: "left",
    letterSpacing: "0px",
    color: theme?.colors?.home?.text,

    marginBottom: "0px",
    [theme.breakpoints.down("xs")]: {
      fontSize: "22px",
    },
  },
  switchLabel: {
    fontFamily: "Poppins",
    fontSize: "15px",
    fontWeight: "bold",
    lineHeight: "20px",
    textAlign: "left",
    letterSpacing: "0px",
    color: theme?.colors?.home?.text,
  },
  switchIcon: {
    width: "20px",
    height: "20px",
  },
  switchTrack: {
    opacity: "0.8 !important",
    background: `${theme?.colors?.wallet?.buttonBackground} !important`,
  },
  mediaLabel: {
    fontFamily: "Poppins",
    fontSize: "25px",
    fontWeight: "lighter",
    lineHeight: "30px",
    textAlign: "left",
    letterSpacing: "0px",
    color: theme?.colors?.home?.text,
    marginBottom: "10px",
    [theme.breakpoints.up("sm")]: {
      marginBottom: "20px",
    },
  },
  completedPoolsWrapper: {
    display: "grid",
    width: "100%",
    gridTemplateColumns: "1fr",
    gridColumnGap: "30px",
    gridRowGap: "40px",

    [theme.breakpoints.up("md")]: {
      display: "grid",
      gridTemplateColumns: "1fr 1fr",
      gridColumnGap: "30px",
      gridRowGap: "40px",
    },

    [theme.breakpoints.up("lg")]: {
      display: "grid",
      gridTemplateColumns: "1fr 1fr 1fr",
      gridColumnGap: "2%",
      gridRowGap: "20px",
    },
    marginBottom: "64px",
  },
  poolsWrapper: {
    display: "grid",
    gridTemplateColumns: "1fr",
    gridColumnGap: "30px",
    gridRowGap: "40px",

    [theme.breakpoints.up("md")]: {
      display: "grid",
      gridTemplateColumns: "1fr 1fr",
      gridColumnGap: "30px",
      gridRowGap: "40px",
    },

    [theme.breakpoints.up("lg")]: {
      display: "grid",
      gridTemplateColumns: "1fr 1fr 1fr",
      gridColumnGap: "2%",
      gridRowGap: "20px",
    },
  },
  completedPools: {
    marginBottom: "20px",
  },
  poolsAluminiWrapper: {
    padding: "20px",
    borderRadius: "40px",
    display: "grid",
    gridTemplateColumns: "1fr",
    gridColumnGap: "30px",
    gridRowGap: "40px",

    [theme.breakpoints.up("md")]: {
      display: "grid",
      gridTemplateColumns: "1fr 1fr",
      gridColumnGap: "30px",
      gridRowGap: "40px",
    },

    [theme.breakpoints.up("lg")]: {
      display: "grid",
      gridTemplateColumns: "1fr 1fr 1fr",
      gridColumnGap: "30px",
      gridRowGap: "40px",
    },
  },
  poolsPartnersWrapper: {
    padding: "20px",
    borderRadius: "40px",
    display: "grid",
    gridTemplateColumns: "1fr",
    gridColumnGap: "30px",
    gridRowGap: "40px",

    [theme.breakpoints.up("md")]: {
      padding: "10px",
      display: "grid",
      gridTemplateColumns: "1fr 1fr",
      gridColumnGap: "30px",
      gridRowGap: "40px",
    },

    [theme.breakpoints.up("lg")]: {
      display: "grid",
      gridTemplateColumns: "1fr 1fr 1fr",
      gridColumnGap: "30px",
      gridRowGap: "40px",
    },
  },
  poolItemWrapper: {
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "flex-start",
  },
  text: {
    fontSize: "16px",
    fontWeight: "lighter",
    textAlign: "left",
    color: theme?.colors?.home?.text,
    lineHeight: "24px",
    marginBottom: "15px",
    marginTop: "0px",
    [theme.breakpoints.up("md")]: {
      fontSize: "20px",
    },
  },
  poolButton: {
    borderRadius: "20px",
    boxShadow: "0 1px 2px 0 rgba(0,0,0,.05)",
    backgroundColor: theme?.colors?.wallet?.buttonBackground,
    color: theme?.colors?.wallet?.buttonTextSecondary,
    textTransform: "capitalize",
    padding: "12px",

    "&:hover": {
      backgroundColor: theme?.colors?.wallet?.buttonBackgroundHover,
    },
    fontFamily: "Poppins",

    width: "100%",

    [theme.breakpoints.up("md")]: {
      width: "200px",
      padding: "16px",
    },
  },
  joinButton: {
    borderRadius: "20px",
    boxShadow: "0 1px 2px 0 rgba(0,0,0,.05)",
    backgroundColor: "#fff",
    color: theme?.colors?.wallet?.buttonText,
    textTransform: "capitalize",
    padding: "12px",
    border: "1px solid " + theme?.colors?.wallet?.buttonBorder,

    "&:hover": {
      backgroundColor: "transparent",
      color: theme?.colors?.wallet?.buttonBackgroundHover,
      border: "1px solid " + theme?.colors?.wallet?.buttonBackgroundHover,
    },
    fontFamily: "Poppins",
    letterSpace: "0px",
    whiteSpace: "nowrap",

    width: "100%",

    [theme.breakpoints.up("md")]: {
      width: "200px",
      padding: "16px",
    },
  },
  exploreBtn: {
    borderRadius: "20px",
    boxShadow: "0 1px 2px 0 rgba(0,0,0,.05)",
    backgroundColor: "transparent",
    border: "2px solid " + theme?.colors?.wallet?.buttonBorderSecondary,
    color: theme?.colors?.wallet?.buttonTextTertiary,
    textTransform: "capitalize",
    height: "40px",

    fontFamily: "Poppins",
    letterSpace: "0px",
    whiteSpace: "nowrap",

    padding: "12px",
    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: "200px",
      padding: "16px",
    },

    margin: "40px auto 0px",
  },
  loadMoreBtn: {
    borderRadius: "20px",
    boxShadow: "0 1px 2px 0 rgba(0,0,0,.05)",
    backgroundColor: "transparent",
    border: "2px solid " + theme?.colors?.wallet?.buttonBorderSecondary,
    color: theme?.colors?.wallet?.buttonTextTertiary,

    textTransform: "capitalize",
    height: "40px",
    width: "200px",
    padding: "8px 16px",
    fontFamily: "Poppins",
    letterSpace: "0px",
    whiteSpace: "nowrap",

    margin: "40px auto 10px",
  },
  buttonLabel: {
    fontWeight: "medium",
    fontSize: "0.875rem",
    lineHeight: "1.25rem",
    whiteSpace: "nowrap",
  },
  emptyContainer: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  warningContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    width: "fit-content",
    height: "50px",
    padding: "10px 20px",
    backgroundColor: theme?.colors?.wallet?.buttonBackground,
    borderRadius: "12px",
  },
  warningText: {
    color: theme?.colors?.poolCard?.title,
    textAlign: "center",
    fontSize: "20px",
    lineHeight: "25px",
  },
  mediaContainer: {
    display: "flex",
    flexDirection: "column",
    marginBottom: "30px",
    [theme.breakpoints.up("ms")]: {
      marginBottom: "50px",
    },
  },
  mediasWrapper: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    [theme.breakpoints.up("lg")]: {
      flexDirection: "row",
    },
  },
  mediaItem: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "15px",
    [theme.breakpoints.up("lg")]: {
      flex: 1,
      marginRight: "15px",
      alignItems: "flex-start",
      justifyContent: "flex-start",
    },
  },
  partnerLogo: {
    filter: "brightness(1)",
    height: "80px",
    cursor: "pointer",
    maxWidth: "240px",
    width: "100%",
    objectFit: "contain",
    "&:hover": {
      filter: "brightness(1.2)",
    },
    borderRadius: "40px",
    padding: "10px",
  },
  logoImage: {
    left: "-3px",
    top: "-3px",
    position: "absolute",
    height: "40px",
  },
  closeIcon: {
    color: theme?.colors?.header?.closeButton,
    width: "32px",
    height: "32px",
  },
  closeButton: {
    position: "absolute",
    right: "2px",
    top: "2px",
    zIndex: "5",
  },
  bannerImage: {
    width: "100%",
    maxHeight: "290px",
    objectFit: "contain",
    display: "none",

    [theme.breakpoints.up("md")]: {
      display: "block",
    },
  },
  bannerImageMobile: {
    width: "100%",

    display: "block",
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },
  totalBannerDiv: {
    position: "relative",
    width: "100vw",
    height: "100%",
    marginBottom: "10px",
    [theme.breakpoints.up("sm")]: {
      width: "calc(100vw - 330px)",
    },
  },
});

const emitter = Store.emitter;
const dispatcher = Store.dispatcher;
const store = Store.store;

const Home = ({ classes }) => {
  const history = useHistory();
  const theme = useTheme();
  const { account } = useAccount();

  const [currentFinishedSlice, setCurrentFinishedSlice] = useState(1);
  const [currentUpcomingSlice, setCurrentUpcomingSlice] = useState(1);
  const [currentLiveSlice, setCurrentLiveSlice] = useState(1);
  const [livePools, setLivePools] = useState([]);

  const [finishedPools, setFinishedPools] = useState([]);
  const [upcomingPools, setUpcomingPools] = useState([]);

  const [isLivePoolsShown, showLivePools] = useState(true);

  // const [bnbPrice, setBnbPrice] = useState(0);
  // const [totalRaisedUSD, setTotalRaisedUSD] = useState(0);
  const [isBuyModalShown, showBuyModal] = useState(false);
  const [swapTokenAmount, setSwapTokenAmount] = useState(0);
  const [buidlTokenAmount, setBuidlTokenAmount] = useState(0);
  const [swapPrice, setSwapPrice] = useState(0);
  const currentDate = Date.now() / 1000;
  const [isBannerShown, showBanner] = useState(
    currentDate <= (BANNER[theme.type]?.start || 0)
  );

  const getMarketingInfo = async () => {
    // const publicPresales = store.getStore("publicPresales");
    // const _bnbPrice = store.getStore("bnbPrice");
    // const publicPresalesUsdRaised = parseFloat(
    //   toFixed(
    //     Object.values(publicPresales).reduce((totalRaised, presale) => {
    //       return totalRaised.add(bigInt(presale?.totalCollectedWei));
    //     }, bigInt(0)),
    //     18,
    //     4
    //   )
    // );
    // setBnbPrice(_bnbPrice);
    // setTotalRaisedUSD(publicPresalesUsdRaised);
  };

  const getPoolsSummaryReturned = useCallback(() => {
    fetchPools();
    getMarketingInfo();
  }, []);

  const getBalancesReturned = useCallback(() => {
    const buidlBalance = store.getStore("buidlBalance");
    setBuidlTokenAmount(toFixed(buidlBalance, 18, 3));
  }, []);

  useEffect(() => {
    fetchPools();
    fetchSwapData();
    emitter.on(GET_POOLS_SUMMARY_RETURNED, getPoolsSummaryReturned);

    emitter.on(GET_BALANCES_RETURNED, () => {
      getBalancesReturned();
    });
    emitter.on(GET_SWAP_INFO_RETURNED, () => {
      fetchSwapData();
    });

    return () => {
      emitter.removeListener(
        GET_POOLS_SUMMARY_RETURNED,
        getPoolsSummaryReturned
      );
      emitter.removeListener(GET_BALANCES_RETURNED, getBalancesReturned);
    };
  }, [getBalancesReturned, getPoolsSummaryReturned]);

  useEffect(() => {
    const localLivePools =
      localStorage.getItem("@Starter:showLivePools") === "true" ?? true;

    showLivePools(localLivePools);
  }, []);

  const fetchSwapData = () => {
    const swapData = store.getStore("swapData");

    setSwapTokenAmount(
      toFixed(swapData.swapTokenBalance, swapData.swapTokenDecimals, 3)
    );
    setSwapPrice(toFixed(swapData.swapPrice, 18, 3));
  };

  const fetchPools = () => {
    const publicPresales = store.getStore("publicPresales");
    const currenTimestamp = Math.floor(Date.now() / 1000);

    const filteredPublicPresales = sortPools(
      Object.values(publicPresales).filter(
        (presale) =>
          !presale?.presaleCancelled && presale?.certified && presale?.visible
      )
    );

    const livePresales = filteredPublicPresales.filter(
      (presale) =>
        parseInt(presale.openTime) <= currenTimestamp &&
        parseInt(presale.closeTime) > currenTimestamp &&
        parseFloat(
          toFixed(
            bigInt(presale?.totalCollectedWei),
            tokens[presale?.fundingTokenAddress]?.decimals ?? 18,
            6
          )
        ) <
          parseFloat(
            toFixed(
              bigInt(presale?.hardCapInWei),
              tokens[presale?.fundingTokenAddress]?.decimals ?? 18,
              6
            )
          ) -
            parseFloat(
              toFixed(
                bigInt(presale?.minInvestInWei || "0"),
                tokens[presale?.fundingTokenAddress]?.decimals ?? 18,
                6
              )
            )
    );

    const finishedPresales = filteredPublicPresales.filter((presale) => {
      const presaleClosed = parseInt(presale.closeTime) < currenTimestamp;
      const softCapReached =
        parseFloat(
          toFixed(
            bigInt(presale?.softCapInWei),
            tokens[presale?.fundingTokenAddress]?.decimals ?? 18,
            6
          )
        ) >=
        parseFloat(
          toFixed(
            bigInt(presale?.totalCollectedWei),
            tokens[presale?.fundingTokenAddress]?.decimals ?? 18,
            6
          )
        );

      const hardCapReached =
        parseFloat(
          toFixed(
            bigInt(presale?.totalCollectedWei),
            tokens[presale?.fundingTokenAddress]?.decimals ?? 18,
            6
          )
        ) >=
        parseFloat(
          toFixed(
            bigInt(presale?.hardCapInWei),
            tokens[presale?.fundingTokenAddress]?.decimals ?? 18,
            6
          )
        ) -
          parseFloat(
            toFixed(
              bigInt(presale?.minInvestInWei || "0"),
              tokens[presale?.fundingTokenAddress]?.decimals ?? 18,
              6
            )
          );

      return (presaleClosed && softCapReached) || hardCapReached;
    });

    const upcomingPresales = filteredPublicPresales.filter(
      (presale) => parseInt(presale.openTime) > currenTimestamp
    );

    setLivePools(livePresales);
    setFinishedPools(finishedPresales);
    setUpcomingPools(upcomingPresales);
  };

  const onSwap = (amount, amountOut, direction) => {
    const minAmountOut = (parseFloat(amountOut) * 995) / 1000;

    dispatcher.dispatch({
      type: SWAP,
      content: {
        amount: amount,
        amountOut: minAmountOut,
        direction,
      },
    });
  };

  return (
    <div className={classes.root}>
      <Fade in={true} timeout={{ enter: 1000 }}>
        <div className={classes.mainContainer}>
          <Typography
            className={
              theme?.type === "pulse"
                ? classes.mainHeaderGradient
                : classes.mainHeader
            }
            variant="h1"
          >
            Backing Tomorrow’s <br />
            Success Stories Today
          </Typography>
          {/* {theme?.type === "bsc" && totalRaisedUSD > 0 && bnbPrice < 500 && (
            <Typography className={classes.header} variant="h1">
              <span className={classes.headerSecondary}>
                {totalRaisedUSD.toLocaleString()} {theme?.symbol || "BNB"}
              </span>
              &nbsp;Raised on BSC
            </Typography>
          )}
          {theme?.type === "bsc" && totalRaisedUSD > 0 && bnbPrice >= 500 && (
            <Typography className={classes.header} variant="h1">
              <span className={classes.headerSecondary}>
                $
                {parseFloat(
                  (totalRaisedUSD * bnbPrice).toFixed(0)
                ).toLocaleString()}{" "}
                USD
              </span>
              &nbsp;Raised on BSC
            </Typography>
          )} */}
          <Typography className={classes.headerSubText} variant="h2">
            Join the onchain capital revolution, where entrepreneurs connect
            with visionary backers to create a new future
          </Typography>
          <div className={classes.headerActionContainer}>
            <Button
              classes={{
                root: classes.poolButton,
                label: classes.buttonLabel,
              }}
              onClick={() => {
                history.push("/pools");
              }}
            >
              View all Projects
            </Button>
            <Button
              classes={{
                root: classes.joinButton,
                label: classes.buttonLabel,
              }}
              onClick={() => {
                showBuyModal(true);
              }}
            >
              Get BUIDL
            </Button>
          </div>

          <FadeInWhenVisible duration={0.83} delay={0.1}>
            <div className={classes.infoCardContainerWrapper}>
              <div className={classes.infoCardTitle}>
                <Typography className={classes.infoCardLabel}>
                  100% Onchain Launchpad for Early Stage Tokenized Ventures
                </Typography>
              </div>

              <div className={classes.infoCardContainer}>
                <InfoCard title="$45M+" description="Raised Onchain" />
                <InfoCard title="63" description="Total IDOS" />
                <InfoCard title="20k+" description="Cryptonauts" />
              </div>
            </div>
          </FadeInWhenVisible>

          <div className={classes.mainBody}>
            {upcomingPools.length > 0 && (
              <div className={classes.poolsContainer}>
                <Typography className={classes.poolsLabel}>
                  Upcoming Projects
                  <img
                    src={LogoPng}
                    alt="logo"
                    style={{ width: "42px", height: "42px" }}
                  />
                </Typography>
                <FadeInWhenVisible duration={0.83} delay={0.1}>
                  <div className={classes.poolsWrapper}>
                    {upcomingPools
                      .slice(0, currentUpcomingSlice * 3)
                      .map((pool) => {
                        return (
                          <div
                            className={classes.poolItemWrapper}
                            key={pool.saleTitle}
                          >
                            <CompletedProjectCard
                              key={pool.tokenAddress}
                              pool={pool}
                            />
                          </div>
                        );
                      })}
                  </div>
                </FadeInWhenVisible>
                {currentUpcomingSlice * 3 < upcomingPools.length && (
                  <Button
                    classes={{
                      root: classes.loadMoreBtn,
                      label: classes.buttonLabel,
                    }}
                    onClick={() => {
                      setCurrentUpcomingSlice((prevState) => prevState + 1);
                    }}
                  >
                    Load more
                  </Button>
                )}
              </div>
            )}
            {isBannerShown && BANNER[theme.type] && (
              <FadeInWhenVisible duration={0.83} delay={0.1}>
                <div
                  className={classes.adContainer}
                  onClick={() => {
                    window.open(BANNER[theme.type].link, "_blank");
                  }}
                >
                  <IconButton
                    aria-label="close"
                    className={classes.closeButton}
                    onClick={(ev) => {
                      ev.stopPropagation();
                      showBanner(false);
                    }}
                  >
                    <CloseIcon className={classes.closeIcon} />
                  </IconButton>
                  <img
                    src={BANNER[theme.type].image}
                    alt="banner"
                    className={classes.bannerImage}
                  />
                  <img
                    src={BANNER[theme.type].mobileImage}
                    alt="banner"
                    className={classes.bannerImageMobile}
                  />
                </div>
              </FadeInWhenVisible>
            )}
            {finishedPools.length > 0 && (
              <FadeInWhenVisible duration={0.83} delay={0.1}>
                <div className={classes.completedContainer}>
                  <div className={classes.completedHeader}>
                    <div>
                      <Typography className={classes.completedTitle}>
                        Funded Projects
                      </Typography>
                      <p className={classes.completedProjectsLabel}>
                        Projects that have been completely funded
                      </p>
                    </div>
                    <div className={classes.completedRightAlign}>
                      <div className={classes.completedInfoBoxLeft}>
                        <p className={classes.completedInfoBoxTitle}>
                          Total Projects
                        </p>
                        <p className={classes.completedInfoBoxDescription}>
                          {finishedPools.length}
                        </p>
                      </div>
                      <div className={classes.completedInfoBoxRight}>
                        <p className={classes.completedInfoBoxTitle}>
                          Total Raised
                        </p>
                        <p className={classes.completedInfoBoxDescription}>
                          {finishedPools
                            .reduce((acc, currentPool) => {
                              const totalCollected = parseFloat(
                                toFixed(
                                  bigInt(currentPool.totalCollectedWei),
                                  tokens[currentPool?.fundingTokenAddress]
                                    ?.decimals ?? 18,
                                  2
                                )
                              );

                              return (acc += Number(totalCollected));
                            }, 0)
                            .toFixed(2)}
                          {/* todo: fix */}
                          {/* {tokens[currentPool?.fundingTokenAddress] || { label: "BNB" }}{" "} */}{" "}
                          USDC
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className={classes.completedPoolsWrapper}>
                    {finishedPools
                      .slice(0, currentFinishedSlice * 3)
                      .map((pool) => {
                        return (
                          <div
                            className={classes.poolItemWrapper}
                            key={pool.saleTitle}
                          >
                            <CompletedProjectCard
                              key={pool.tokenAddress}
                              pool={pool}
                            />
                          </div>
                        );
                      })}
                  </div>

                  {currentFinishedSlice * 3 < finishedPools.length && (
                    <Button
                      classes={{
                        root: classes.loadMoreBtn,
                        label: classes.buttonLabel,
                      }}
                      onClick={() => {
                        setCurrentFinishedSlice((prevState) => prevState + 1);
                      }}
                    >
                      Load more
                    </Button>
                  )}
                </div>
              </FadeInWhenVisible>
            )}

            <FadeInWhenVisible duration={0.83} delay={0.1}>
              <div className={classes.aboutContainer}>
                <Typography className={classes.poolsLabel}>
                  Learn about Starter
                </Typography>

                <div className={classes.aboutInnerContainer}>
                  <AboutStarterCard
                    image={SwCJpg}
                    size="lg"
                    descriptionContainerStyles={{ padding: "32px 16px" }}
                    title="Starter Labs Founder Selected as 1 of 50 to Join Coinbase and other Founders for the Inaugural #StandWithCrypto Day in D.C."
                    description="Representing the Atlanta Blockchain Center and the State of Georgia, our Founder stomped the halls of Congress with Coinbase and other crypto founders to Stand With Crypto. Atlanta Blockchain Center is a product of Starter Labs and is the only physical events, coworking and IRL incubator for crypto builders in the USA."
                    onClick={() => {
                      window.open(
                        "https://twitter.com/coinbase/status/1707075426705682594",
                        "_blank"
                      );
                    }}
                  />
                  <div className={classes.aboutRightContainer}>
                    <AboutStarterCard
                      size="sm"
                      image={ABCandCoinbaseJpg}
                      title="Starter Labs and Coinbase Hosts: Crypto Town Hall Atlanta with Former Mayor"
                      onClick={() => {
                        window.open(
                          "https://www.youtube.com/live/ETq_UZ1aRGQ?feature=shared",
                          "_blank"
                        );
                      }}
                    />
                    <AboutStarterCard
                      size="sm"
                      image={StarterIncubatorJpg}
                      title="Starter BUIDLs First Ever Crypto IRL Incubator and Coworking Space in USA"
                      onClick={() => {
                        window.open(
                          "https://starterlabs.medium.com/starter-labs-buidls-irl-with-its-first-physical-blockchain-incubator-and-coworking-dao-in-atlanta-5a35c77ab8d0",
                          "_blank"
                        );
                      }}
                    />
                  </div>
                </div>

                <Button
                  classes={{
                    root: classes.exploreBtn,
                    label: classes.buttonLabel,
                  }}
                  onClick={() => {
                    window.open("https://starterlabs.medium.com", "_blank");
                  }}
                >
                  Explore our blog {">"}
                </Button>
              </div>
            </FadeInWhenVisible>

            {livePools.length > 0 && (
              <div className={classes.poolsContainer}>
                <div className={classes.poolLabelContainer}>
                  <Typography className={classes.poolsLabel}>
                    Live Projects
                  </Typography>
                  <FormControlLabel
                    classes={{ label: classes.switchLabel }}
                    value="start"
                    control={
                      <Switch
                        classes={{ track: classes.switchTrack }}
                        color="primary"
                        size="medium"
                        checked={isLivePoolsShown}
                        onChange={(ev) => {
                          localStorage.setItem(
                            "@Starter:showLivePools",
                            String(ev.target.checked)
                          );
                          showLivePools(ev.target.checked);
                        }}
                        icon={
                          <img
                            className={classes.switchIcon}
                            src={theme.logoImage}
                            alt="logo"
                          />
                        }
                        checkedIcon={
                          <img
                            className={classes.switchIcon}
                            src={theme.logoImage}
                            alt="logo"
                          />
                        }
                      />
                    }
                    label="View Live Projects"
                    labelPlacement="start"
                  />
                </div>
                {isLivePoolsShown &&
                  livePools.slice(0, currentLiveSlice * 3).length > 0 && (
                    <FadeInWhenVisible duration={0.83} delay={0.1}>
                      <div className={classes.poolsWrapper}>
                        {livePools
                          .slice(0, currentLiveSlice * 3)
                          .map((pool) => {
                            return (
                              <div
                                className={classes.poolItemWrapper}
                                key={pool.saleTitle}
                              >
                                <CompletedProjectCard
                                  key={pool.tokenAddress}
                                  pool={pool}
                                />
                              </div>
                            );
                          })}
                      </div>
                    </FadeInWhenVisible>
                  )}
                {isLivePoolsShown &&
                  currentLiveSlice * 3 < livePools.length && (
                    <Button
                      classes={{
                        root: classes.loadMoreBtn,
                        label: classes.buttonLabel,
                      }}
                      onClick={() => {
                        setCurrentLiveSlice((prevState) => prevState + 1);
                      }}
                    >
                      Load more
                    </Button>
                  )}
              </div>
            )}
            <FadeInWhenVisible duration={0.83} delay={0.1}>
              <div className={classes.howToArticlesContainerWrapper}>
                <div className={classes.howToArticlesTitle}>
                  <Typography className={classes.howToArticlesLabel}>
                    Guides for Investors & BUIDLers
                  </Typography>
                </div>

                <div className={classes.howToArticlesContainer}>
                  <HowToArticleCard
                    image={GuideTierPng}
                    href="https://docs.starter.xyz/overview/tiers-and-staking"
                    title="How to Secure a Staking Tier"
                    description="Skip the Line: Tiers are a great way to guarantee your place in the front row to amazing ideas."
                  />
                  <HowToArticleCard
                    image={GuideListPng}
                    href="https://docs.starter.xyz/overview/listing-projects"
                    title="Insights into Getting Listed"
                    description="Learn how to get your project listed for funding by the community or as a Certified BUIDLer."
                  />
                  <HowToArticleCard
                    image={GuideBuidlPng}
                    href="https://docs.starter.xyz/overview/tokenomics"
                    title="A Deeper Dive into $BUIDL Mechanics"
                    description="$BUIDL provides holders unique access to the builders of tomorrow while rewarding early supporters."
                  />
                  <HowToArticleCard
                    image={GuideVotinglPng}
                    href="https://docs.starter.xyz/product-guides/how-to-research-and-vote-on-upcoming-projects"
                    title="Research and Voting on Projects"
                    description="True onchain capital formation that gives our community a voice to decide what gets funded."
                  />
                </div>
                <Button
                  classes={{
                    root: classes.exploreBtn,
                    label: classes.buttonLabel,
                  }}
                  onClick={() => {
                    window.open("https://docs.starter.xyz", "_blank");
                  }}
                >
                  View documentation {">"}
                </Button>
              </div>
            </FadeInWhenVisible>
          </div>
        </div>
      </Fade>
      <BuyModalBox
        modalOpen={isBuyModalShown}
        closeModal={() => {
          showBuyModal(false);
        }}
        bnbBalance={swapTokenAmount}
        buidlBalance={buidlTokenAmount}
        price={swapPrice}
        onSwap={onSwap}
        account={account}
        url={defaultBuyUrls[theme?.type]}
      />
      <div className="klaviyo-form-YdiSzv" />
    </div>
  );
};

export default withNamespaces()(withRouter(withStyles(styles)(Home)));
